import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@solinkcorp/solink-ui';
import React from 'react';

export interface ThresholdConflictMessageProps {
  message: string;
  labelCount: number;
  id: string;
}

export function ThresholdConflictMessage({
  message,
  labelCount,
  id,
}: ThresholdConflictMessageProps): React.ReactElement {
  const content = (
    <p
      id={id}
      className={cn(
        'text-xs font-normal leading-4 text-text-error',
        labelCount > 1 && 'min-w-0 truncate',
      )}
      role="alert"
    >
      {message}
    </p>
  );
  if (labelCount > 1) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent>
          <p className="max-w-sm">{message}</p>
        </TooltipContent>
      </Tooltip>
    );
  }
  return content;
}
